module.exports = __webpack_public_path__ + "141f1aaecb9c497d6536bac1157c92b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/trailer_preview-420.jpg
// module id = 557
// module chunks = 0